import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountCashback.js';
import Loader from 'Loader.js';
import Pagination from 'Pagination.js';
import _map from 'lodash/map';
import _size from 'lodash/size';
import classNames from 'classnames';
import { translation, formatMoney, redirect } from 'helpers/utilsHelper.js';
import { formatDate, substractDays, substractMonths, compareAsc } from 'helpers/datesHelper.js';
import {
  changeDateByType,
  fetchCashbackByFilter,
  setCurrentPage,
} from 'accountCashbackActions.js';
import { loadCustomerOffersBalances, withdrawCustomerOfferBalance } from 'offersActions.js';
import ModalOpacity from 'ModalOpacity.js';
import { CSSTransition } from 'react-transition-group';
import ArrowBack from 'arrow-back.svg';

class AccountCashback extends Component {
  durationAnimation = 3000;

  state = {
    showCashbackPlusWithdrawModal: false,
    cashbackAmountWithdrawed: null,
    cashbackWithdrawStep: 1,
    customerBalanceSaved: null,
    isSubmitBtnActive: true,
  };

  toggleModal = (type) => {
    this.setState((prevState) => {
      return { ...prevState, [type]: !prevState[type] };
    });
  };

  updateCashbackAmountWithdrawed = (amount) => {
    this.setState({ cashbackAmountWithdrawed: amount });
  };

  updateCustomerBalanceSaved = (amount) => {
    this.setState({ customerBalanceSaved: amount });
  };

  updateCashbackWithdrawStep = (step) => {
    this.setState({ cashbackWithdrawStep: step });
  };

  componentDidMount = async () => {
    const { loadCustomerOffersBalances, fetchCashbackByFilter } = this.props;
    try {
      await loadCustomerOffersBalances()
    } catch (error) {
      console.log('AccountCashback.componentDidMount:' + error);
    } finally {
      await fetchCashbackByFilter();
    }
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchCashbackByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchCashbackByFilter();
    });
  };

  onChangeFilter = (dateFilterType) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const today = new Date();

    let startDate = today;

    switch (dateFilterType) {
      case "1month":
        startDate = substractMonths(today, 1);
        break
      case "24h":
      default:
        startDate = substractDays(today, 1);
        break;
    }

    batch(() => {
      changeDateByType('startDate', startDate);
      changeDateByType('endDate', today);
      fetchCashbackByFilter();
    })
  };

  compareDates = (dateLeft, dateRight) => {
    dateLeft = new Date(formatDate(dateLeft, 'yyyy-MM-dd'));
    dateRight = new Date(formatDate(dateRight, 'yyyy-MM-dd'));
    const result = compareAsc(dateLeft, dateRight);
    return !result;
  };

  goPage = (currentPage) => {
    const { fetchCashbackByFilter, setCurrentPage } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchCashbackByFilter();
      });
    } catch (error) {
      console.log('goPage:' + error);
    }
  };

  getCashbackBalanceAmount = (list, currencyCode) => {
    const offer = list.find((o) => o.identifier == process.env.CASHBACK_PLUS_OFFER_IDENTIFIER);
    let balance = '0.00';
    if (offer) {
      balance = formatMoney(offer.customerBalance);
    }
    return balance + currencyCode;
  };

  getOfferIdDefinitionForCashback = () => {
    const { offersBalances } = this.props;
    const offer = offersBalances.find(
      (o) => o.identifier == process.env.CASHBACK_PLUS_OFFER_IDENTIFIER
    );
    let offerCashback = {};
    if (offer) {
      offerCashback = {
        offerDefinitionId: offer.offerIdDefinition,
        customerBalance: offer.customerBalance,
      };
    }
    return offerCashback;
  };

  handleCashbackWithdrawSubmit = async (event) => {
    event.preventDefault();
    this.setState((prevState) => ({ isSubmitBtnActive: !prevState.isSubmitBtnActive }));
    const { withdrawCustomerOfferBalance, balance } = this.props;

    const offerCashback = this.getOfferIdDefinitionForCashback();
    try {
      this.updateCustomerBalanceSaved(balance);
      const amount = await withdrawCustomerOfferBalance(offerCashback);
      if (amount) {
        this.updateCashbackAmountWithdrawed(amount);
        this.toggleModal('showCashbackPlusWithdrawModal');
        setTimeout(() => this.updateCashbackWithdrawStep(2), this.durationAnimation);
      }
      this.setState((prevState) => ({ isSubmitBtnActive: !prevState.isSubmitBtnActive }));
    } catch (error) {
      console.log(error);
      this.setState((prevState) => ({ isSubmitBtnActive: !prevState.isSubmitBtnActive }));
    }
  };

  isWithdrawDisabled = () => {
    let isWithdrawDisabled = false;
    const { offerDefinitionId, customerBalance } = this.getOfferIdDefinitionForCashback();
    if (!offerDefinitionId || !customerBalance) {
      isWithdrawDisabled = true;
    }

    return isWithdrawDisabled;
  };

  render() {
    const {
      isPending,
      error,
      data,
      isNextPageAvailable,
      currentPage,
      limit,
      offersBalances,
      startDate,
      endDate
    } = this.props;
    const {
      showCashbackPlusWithdrawModal,
      cashbackAmountWithdrawed,
      customerBalanceSaved,
      cashbackWithdrawStep,
    } = this.state;

    const today = new Date();
    const is24HourBtnActive = 
      this.compareDates(startDate, substractDays(today, 1)) &&
      this.compareDates(endDate, today)
    const is1MonthBtnActive =
      this.compareDates(startDate, substractMonths(today, 1)) &&
      this.compareDates(endDate, today)

    return (
      <S.AccountCashback>
        <ModalOpacity
          isOpen={showCashbackPlusWithdrawModal}
          toggleOpen={this.toggleModal.bind(this, 'showCashbackPlusWithdrawModal')}
          showHeader={false}
          showHeaderIcon={false}
          showHeaderTitle={false}
          showCloseIcon={false}
          padding="0px"
          width="350px"
          preventCloseOnOverlay={true}
        >
          <S.AccountCashbackWithdrawModal>
            {cashbackWithdrawStep == 1 && (
              <S.AccountCashbackWithdrawModalStep1>
                <S.AccountCashbackWithdrawModalText>
                  {' '}
                  {translation('account_cashback')}{' '}
                </S.AccountCashbackWithdrawModalText>
                <CSSTransition
                  in={showCashbackPlusWithdrawModal}
                  timeout={5000}
                  className="modal-text-animation"
                  classNames="modal-text-animation"
                  unmountOnExit
                >
                  <S.AccountCashbackWithdrawModalText>
                    {' '}
                    {cashbackAmountWithdrawed && formatMoney(cashbackAmountWithdrawed)}
                    {translation('common_pln')}{' '}
                  </S.AccountCashbackWithdrawModalText>
                </CSSTransition>
                <S.AccountCashbackWithdrawModalText>
                  {' '}
                  {translation('account_cashback')}{' '}
                </S.AccountCashbackWithdrawModalText>
                <CSSTransition
                  in={showCashbackPlusWithdrawModal}
                  timeout={5000}
                  className="modal-text-animation"
                  classNames="modal-text-animation"
                  unmountOnExit
                >
                  <S.AccountCashbackWithdrawModalText>
                    {' '}
                    {customerBalanceSaved && formatMoney(customerBalanceSaved)}
                    {translation('common_pln')}{' '}
                  </S.AccountCashbackWithdrawModalText>
                </CSSTransition>
                <S.AccountCashbackMoney></S.AccountCashbackMoney>
              </S.AccountCashbackWithdrawModalStep1>
            )}
            {cashbackWithdrawStep == 2 && (
              <S.AccountCashbackWithdrawModalStep2>
                <S.AccountCashbackWithdrawModalText>
                  {' '}
                  {translation('account_cashbackSuccess')}{' '}
                </S.AccountCashbackWithdrawModalText>
                <S.AccountCashbackWithdrawModalTextSmall>
                  {' '}
                  {translation('account_cashbackPaid')}{' '}
                </S.AccountCashbackWithdrawModalTextSmall>
                <S.AccountCashbackWithdrawModalTextSmall>
                  {' '}
                  {cashbackAmountWithdrawed && formatMoney(cashbackAmountWithdrawed)}
                  {translation('common_pln')}{' '}
                </S.AccountCashbackWithdrawModalTextSmall>
                <S.AccountCashbackWithdrawModalTextSmall>
                  {' '}
                  {translation('account_cashback')}{' '}
                </S.AccountCashbackWithdrawModalTextSmall>
                <S.AccountCashbackSuccessIcon></S.AccountCashbackSuccessIcon>
                <S.AccountCashbackWithdrawModalText>
                  {' '}
                  {translation('account_cashbackAccount')}{' '}
                </S.AccountCashbackWithdrawModalText>
                <S.AccountCashbackWithdrawModalText>
                  {' '}
                  {customerBalanceSaved &&
                    formatMoney(customerBalanceSaved + cashbackAmountWithdrawed)}
                  {translation('common_pln')}{' '}
                </S.AccountCashbackWithdrawModalText>
                <S.AccountCashbackWithdrawModalButton
                  onClick={this.toggleModal.bind(this, 'showCashbackPlusWithdrawModal')}
                >
                  {translation('account_cashbackPlayNow')}
                </S.AccountCashbackWithdrawModalButton>
              </S.AccountCashbackWithdrawModalStep2>
            )}
          </S.AccountCashbackWithdrawModal>
        </ModalOpacity>

        <S.AccountCashbackWithdraw>
          <S.AccountCashbackWrapper onSubmit={this.handleCashbackWithdrawSubmit}>
            <S.TopRow>
              <S.ArrowBack
                onClick={() => redirect('/konto')}
                dangerouslySetInnerHTML={{ __html: ArrowBack }}
              />
              <S.BalanceLabel>{translation('account_cashback')}</S.BalanceLabel>
              <S.BalanceAmount>
                {this.getCashbackBalanceAmount(offersBalances, translation('common_pln'))}
              </S.BalanceAmount>
            </S.TopRow>

            <S.WithdrawButton
              disabled={this.isWithdrawDisabled()}
              data-active={!this.state.isSubmitBtnActive}
              type="submit"
            >
              {translation('account_withdrawButton')}
            </S.WithdrawButton>

            {error && (
              <S.AccountCashbackMessage>{translation(error.message)}</S.AccountCashbackMessage>
            )}
          </S.AccountCashbackWrapper>
        </S.AccountCashbackWithdraw>

        <S.AccountCashbackList>
          <S.CashbackFiltersLabel>{translation('cashback_history')}</S.CashbackFiltersLabel>

          <S.CashbackFiltersBtns className="cashback-btns-wrapper">
            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, '24h')}
              className={classNames({ active: is24HourBtnActive })}
            >
              {translation('account_cashback24h')}
            </S.FilterBtn>
            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, '1month')}
              className={classNames({ active: is1MonthBtnActive })}
            >
              {translation('account_cashback1month')}
            </S.FilterBtn>
          </S.CashbackFiltersBtns>

          <S.CashbackFiltersDates className="wallet-filters-dates">
            <S.Datepicker>
              <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
              <input
                type="date"
                value={formatDate(startDate, 'yyyy-MM-dd')}
                onChange={(event) => this.handleChangeStart(event.target.value)}
              />
              <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
            </S.Datepicker>
            <S.Datepicker>
              <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
              <input
                type="date"
                value={formatDate(endDate, 'yyyy-MM-dd')}
                onChange={(event) => this.handleChangeEnd(event.target.value)}
              />
              <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
            </S.Datepicker>
          </S.CashbackFiltersDates>

          <S.CashbackList className="cashback-list">
            {isPending ? (
              <Loader />
            ) : (
              <>
                <S.Table className="cashback-table">
                  <S.Head>
                    <S.Row className="row">
                      <S.Th className="slip-id">{translation('account_cashback_betSlipId')}</S.Th>
                      <S.Th className="time">{translation('account_cashback_createTime')}</S.Th>
                      <S.Th className="name">{translation('account_cashback_offerName')}</S.Th>
                      <S.Th style={{ display: 'none' }}>
                        {translation('account_cashback_stake')}
                      </S.Th>
                      <S.Th className="paid">{translation('account_cashback_paidValue')}</S.Th>
                    </S.Row>
                  </S.Head>

                  <S.Body>
                    {_map(
                      data,
                      (
                        {
                          betSlipIdEncrypted,
                          createTime,
                          offerId,
                          descriptionKey,
                          paidValue = 0,
                          nameKey,
                          offerName,
                          baseValue,
                        },
                        index
                      ) => {
                        const rowClazz = (index + 1) % 2 ? 'row odd' : 'row even';
                        return (
                          <S.Row className={rowClazz} key={offerId}>
                            <S.Td className="slip-id">{betSlipIdEncrypted}</S.Td>
                            <S.Td className="time">{formatDate(createTime, 'dd/MM/yyyy')}</S.Td>
                            <S.Td className="name">{offerName}</S.Td>
                            <S.Td style={{ display: 'none' }}>
                              {formatMoney(baseValue)} {translation('common_pln')}
                            </S.Td>
                            <S.Td className="paid">
                              {formatMoney(paidValue)} {translation('common_pln')}
                            </S.Td>
                          </S.Row>
                        );
                      }
                    )}

                    {!_size(data) && (
                      <S.Row className="no-result">
                        <S.Td colSpan="5">{translation('account_cashback_notFound')}</S.Td>
                      </S.Row>
                    )}
                  </S.Body>
                </S.Table>

                {_size(data) > 0 && (
                  <Pagination
                    currentPage={currentPage}
                    limit={limit}
                    data={data}
                    callback={this.goPage}
                    isNextPageAvailable={isNextPageAvailable}
                  />
                )}
              </>
            )}
          </S.CashbackList>
        </S.AccountCashbackList>
      </S.AccountCashback>
    );
  }
}

const mapStateToProps = (
  {
    AccountCashback: {
      isPending,
      startDate,
      endDate,
      data,
      isNextPageAvailable,
      currentPage,
      limit,
      dateFilterType,
    },
    Auth: {
      user: { currencyCode, balance },
    },
    Offers: { offersBalances, error },
  },
) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    data,
    isNextPageAvailable,
    currentPage,
    limit,
    dateFilterType,
    currencyCode,
    balance,
    offersBalances,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchCashbackByFilter: bindActionCreators(fetchCashbackByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    loadCustomerOffersBalances: bindActionCreators(loadCustomerOffersBalances, dispatch),
    withdrawCustomerOfferBalance: bindActionCreators(withdrawCustomerOfferBalance, dispatch),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountCashback);
